"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.split");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _aliOss = _interopRequireDefault(require("ali-oss"));
var _system = require("@/api/system");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'UploadVideo',
  props: {
    uploadType: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      uploadDisabled: true,
      pauseDisabled: true,
      resumeDisabled: true,
      statusText: false,
      file: null,
      authProgress: 0,
      videoId: '',
      videoName: '',
      signature: '',
      tcVod: null,
      ossClient: null,
      tempCheckpoint: null,
      progress: 0
    };
  },
  created: function created() {
    var _this = this;
    (0, _system.getUploadOssStsToken)().then(function (res) {
      _this.ossClient = new _aliOss.default({
        region: res.data.region,
        accessKeyId: res.data.Credentials.AccessKeyId,
        accessKeySecret: res.data.Credentials.AccessKeySecret,
        stsToken: res.data.Credentials.SecurityToken,
        bucket: res.data.bucket
      });
    }).catch(function () {});
    if (this.value) {
      this.authProgress = 100;
      this.statusText = true;
    }
  },
  methods: {
    uploadALiAction: function uploadALiAction(e) {
      var _this2 = this;
      this.file = e.target.files[0];
      if (this.uploadType && this.file.type.toLowerCase().indexOf(this.uploadType.toLowerCase()) === -1) {
        this.$message.error("\u8BF7\u4E0A\u4F20".concat(this.uploadType, "\u6587\u4EF6"));
        return;
      }
      this.authProgress = 0;
      this.statusText = true;
      this.multipartUpload(this.file, function (res) {
        console.log(res);
        var url = '';
        if (res) {
          url = "https://artimg2.artart.cn/".concat(res.name);
          _this2.$emit('setVideo', url);
        } else {
          _this2.statusText = false;
          _this2.$message.error('上传失败，请重试');
        }
      });
    },
    multipartUpload: function () {
      var _multipartUpload = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(m, cb) {
        var _this3 = this;
        var myDate, imgType, imgT, imgName, imgUrl, result;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              myDate = new Date();
              imgType = m.name.split('.');
              imgT = imgType[imgType.length - 1];
              imgT = imgT.toLowerCase();
              imgName = myDate.getTime().toString() + parseInt(Math.random() * 1000000, 10).toString();
              imgUrl = "".concat(imgName, ".").concat(imgT);
              _context.next = 9;
              return this.ossClient.multipartUpload("node/other/".concat(imgUrl), m, {
                progress: function progress(p, checkpoint) {
                  var progressPercent = Math.ceil(p * 100);
                  _this3.authProgress = progressPercent;
                },
                mime: m.type
              });
            case 9:
              result = _context.sent;
              if (result && result.name) {
                cb(result);
              }
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              if (cb) cb();
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 13]]);
      }));
      function multipartUpload(_x, _x2) {
        return _multipartUpload.apply(this, arguments);
      }
      return multipartUpload;
    }()
  }
};
exports.default = _default;